<template>
  <div class="stepContent">
    <div class="uploadBox">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="100px" style="margin-top: 20px;">
        <el-form-item label="所属公司" prop="cusId">
          <select-text v-model="rowInfo.cusId" code-set-id="" :options="cusOptions"  placeholder="所属公司" style="width: 400px;margin-right: 10px;"/>
        </el-form-item>
      </el-form>
    </div>
    <div class="uploadTip">
      <div class="uploadTip-title">
        温馨提示
      </div>
      <div class="uploadTip-lists">
        <div class="uploadTip-list">
          你可以在此下载<span class="uploadTip-button" @click="exportTemplate">《标准模板》</span>
        </div>
      </div>
    </div>
    <div class="next">
      <el-button  type="primary" @click="submitForm('rowInfo')">下一步</el-button>
    </div>
  </div>
</template>
<script>
import SelectText from '@/components/SelectText/index.vue'
import { exportNullExcel } from  "@/api/cus/empinfo"
import { downloadExcelFile } from  "@/util/util"
import { loadCusList } from  "@/api/cus/cusinfo"
import {mapGetters} from "vuex";
export default {
  components: { SelectText },
  props: {
    typeId: {
      type: String,
      default: ''
    }
  },
  computed: {
    headers() {
      return {
        Authorization: `Bearer ${this.accessToken}`,
      };
    },
    ...mapGetters(['accessToken'])
  },
  data() {
    return {
      cusOptions:[],
      rowInfo: {
        cusId:''
      },
      rules: {
        cusId: [{ required: true, message: '请选择所属公司', trigger: 'change' }],
      }
    }
  },
  mounted() {
    this.loadCusList()
  },
  methods: {
    loadCusList(){
      loadCusList().then(res => {
        this.cusOptions = res.data.data
      })
    },
    // 下载模板
    exportTemplate() {
      let that = this;
      exportNullExcel().then(res => {
        downloadExcelFile(res,that);
      }).catch(resp => {
        that.$notify.error(resp.msg || '下载失败')
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('next',this.rowInfo.cusId) // 跳转下一步
        }
      })
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">

  .uploadBox{
    border:1px solid #eeeeee;
    border-radius: 5px;
    padding:15px;
    margin-bottom: 20px;
  }
  .uploadContent{
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 20px #eeeeee;
    border-radius: 10px;
  }
  .uploadContent .iconfont{
    font-size: 80px;
    color:#cccccc;
  }
  .uploadContent {
    height: 140px;
  }
  .uploadBox >>> .el-upload{
    width: 100%;
    height: 100%;
  }
  .uploadBox >>> .el-upload-dragger{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .uploadBox >>> .el-upload-dragger .el-icon-upload{
    margin-top: 0;
  }
  .uploadText{
    color:#aaaaaa;
  }
  .uploadTip-lists{
    padding-left:20px;
  }
  .uploadTip-list .uploadTip-button{
    color:#269cff;
    text-decoration: underline;
    cursor: pointer;
  }
  .next{
    position: absolute;
    bottom: 20px;
    text-align: center;
    width: 100%;
  }
</style>
